// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"CartDetails_mainContent__2pOZ7","linkContainer":"CartDetails_linkContainer__2NqTe","innerContainer":"CartDetails_innerContainer__50Djo"};